(() => {
  const scripts = new Map();
  const loadScript = (src) => {
    if (!scripts.has(src)) {
      scripts.set(src, new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      }));
    }
    return scripts.get(src);
  };
  const enhance = (element) => {
    if (element.dataset.communityStarted) return;
    element.dataset.communityStarted = 'true';
    const platform = element.dataset.communityPlatform;
    if (platform === 'instagram') {
      const title = `${element.closest('article')?.querySelector('h3')?.textContent.trim() || 'Owl Village'} - Instagram video`;
      const labelFrame = () => {
        const frame = element.querySelector('iframe');
        if (!frame) return false;
        frame.title = title;
        return true;
      };
      if (!labelFrame()) {
        const observer = new MutationObserver(() => {
          if (labelFrame()) observer.disconnect();
        });
        observer.observe(element, { childList: true, subtree: true });
      }
      loadScript('https://www.instagram.com/embed.js')
        .then(() => window.instgrm?.Embeds.process()).catch(() => {});
    } else if (platform === 'pinterest') {
      loadScript('https://assets.pinterest.com/js/pinit.js')
        .then(() => window.PinUtils?.build()).catch(() => {});
    }
  };
  const init = (root) => {
    const elements = root.querySelectorAll('.ov-community__embed');
    if (!('IntersectionObserver' in window)) {
      elements.forEach(enhance);
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        enhance(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '500px' });
    elements.forEach((element) => observer.observe(element));
  };
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
